import { createSelector } from '@reduxjs/toolkit';
const recurringMeetingsRoot = state => state.recurringMeetings;
export const recurringMeetingsSelector = createSelector(recurringMeetingsRoot, ({
  recurringMeetings
}) => recurringMeetings);
export const isPreviousMeetingsMenuOpenSelector = createSelector(recurringMeetingsRoot, ({
  isPreviousMeetingsMenuOpen
}) => isPreviousMeetingsMenuOpen);